import { render, staticRenderFns } from "./DashboardListView.vue?vue&type=template&id=e6fdf010&scoped=true"
import script from "./DashboardListView.vue?vue&type=script&lang=js"
export * from "./DashboardListView.vue?vue&type=script&lang=js"
import style0 from "./DashboardListView.vue?vue&type=style&index=0&id=e6fdf010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fdf010",
  null
  
)

export default component.exports